module.exports = __webpack_public_path__ + "media/images/athletes/1553-d263463946444d01b9a87e83d77ed49f.png";